import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sendContact } from "../actions/formQualiActions";
import propTypes from "prop-types";
import { FormattedHTMLMessage, FormattedMessage, injectIntl } from "react-intl";
import { fanakActionCodesToTranslatedCode } from "../constants/codeAction.js";
import { getQueryParam } from "../utils/Url.js";

const FormQuali = ({ intl }) => {
  const { success, error, pending } = useSelector((state) => state.formQuali);
  const dispatcher = useDispatch();
  const id = getQueryParam("id");
  const email = getQueryParam("email");
  const initialState = {
    first_name: "",
    last_name: "",
    lang: "",
    code_action: "",
    phone: "",
    country: "",
    city: "",
  };
  const [state, setState] = useState(initialState);
  const handleChange = (fieldName) => (event) => {
    const nextState = { ...state };
    nextState[fieldName] = event.target.value;
    setState(nextState);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    dispatcher(sendContact({ ...state }, id, email));
    return false;
  };

  const renderActionCodes = () => {
    const actionCodes = Object.keys(fanakActionCodesToTranslatedCode)
      .map((key) => {
        return {
          key,
          value: intl.formatMessage({
            id: `fanak.formQuali.fields.code_action.${fanakActionCodesToTranslatedCode[key]}`,
          }),
        };
      })
      .sort((a, b) => a.value.localeCompare(b.value));

    return (
      <>
        {actionCodes.map((actionCode) => (
          <option
            key={actionCode.key}
            name="code_action"
            value={actionCode.key}
          >
            {actionCode.value}
          </option>
        ))}
      </>
    );
  };

  if (!email && !id) {
    return (
      <div className="form-quali" style={{ height: "40vh" }}>
        <p>
          <FormattedMessage id="fannac.error" />: No email or id provided !
        </p>
      </div>
    );
  }
  if (success) {
    return (
      <div className="form-quali" style={{ height: "40vh" }}>
        <p>Vos données ont bien été envoyé !</p>
      </div>
    );
  }
  if (pending) {
    return (
      <div className="form-quali" style={{ height: "40vh" }}>
        <p>Chargement en cours...</p>
      </div>
    );
  }

  return (
    <div className="form-quali">
      {error && (
        <p>
          <FormattedMessage id="fannac.error" />: {error.toString()}
        </p>
      )}
      <p>
        <FormattedHTMLMessage id="fanak.formQuali.intro" values={{ email }} />
      </p>
      <form onSubmit={handleSubmit}>
        <select
          name="lang"
          value={state.lang}
          onChange={handleChange("lang")}
          required
        >
          <option value="">
            {intl.formatMessage({ id: "fanak.formQuali.fields.lang" })}
          </option>
          <option value="fr">
            {intl.formatMessage({ id: "fanak.formQuali.fields.lang.fr" })}
          </option>
          <option value="en">
            {intl.formatMessage({ id: "fanak.formQuali.fields.lang.en" })}
          </option>
          <option value="ar">
            {intl.formatMessage({ id: "fanak.formQuali.fields.lang.ar" })}
          </option>
        </select>
        <input
          type="text"
          name="last_name"
          placeholder={intl.formatMessage({
            id: "fanak.formQuali.fields.last_name",
          })}
          value={state.last_name}
          onChange={handleChange("last_name")}
          required
        />
        <input
          type="text"
          name="first_name"
          placeholder={intl.formatMessage({
            id: "fanak.formQuali.fields.first_name",
          })}
          value={state.first_name}
          onChange={handleChange("first_name")}
          required
        />
        <select
          name="code_action"
          value={state.code_action}
          onChange={handleChange("code_action")}
          required
        >
          <option value="">
            {intl.formatMessage({ id: "fanak.formQuali.fields.code_action" })}
          </option>
          {renderActionCodes()}
        </select>

        <input
          type="text"
          name="phone"
          placeholder={intl.formatMessage({
            id: "fanak.formQuali.fields.phone",
          })}
          value={state.phone}
          onChange={handleChange("phone")}
        />
        <input
          type="text"
          name="city"
          value={state.city}
          onChange={handleChange("city")}
          placeholder={intl.formatMessage({
            id: "fanak.formQuali.fields.city",
          })}
        />
        <input
          type="text"
          name="country"
          value={state.country}
          onChange={handleChange("country")}
          placeholder={intl.formatMessage({
            id: "fanak.formQuali.fields.country",
          })}
        />
        <input
          type="submit"
          value={intl.formatMessage({
            id: "fanak.formQuali.submit",
          })}
        />
      </form>
    </div>
  );
};

FormQuali.propTypes = {
  intl: propTypes.object.isRequired,
};

export default injectIntl(FormQuali);
